import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { PlayCircleSolid } from '../ui/PlayCircleSolid';
import { translate } from '../../../shared/helpers';

import * as styles from './styles.ve.css';

interface TestimonialCardProps {
  imageSrc: string;
  name: string;
  position: string;
  quote: string;
  onClick?: () => void;
}

const TestimonialCard = ({ imageSrc, name, position, quote, onClick }: TestimonialCardProps) => (
  <Container className={styles.cardContainer} onClick={onClick} cursor="pointer">
    <Container className={styles.cardImageContainer}>
      <Image src={imageSrc} alt={name} height="100%" width="100%" objectFit="cover" />
    </Container>
    <Container className={styles.cardOverlay}>
      <Container className={styles.iconContainer}>
        <PlayCircleSolid />
      </Container>
      <Container className={styles.textContainer}>
        <Text color="white" className={styles.nameText}>
          {translate(name)}
        </Text>
        <Text color="white" className={styles.positionText}>
          {translate(position)}
        </Text>
        <Text color="white" className={styles.quoteText}>
          {translate(quote)}
        </Text>
      </Container>
    </Container>
  </Container>
);

export default TestimonialCard;
